import React, { FC } from 'react';
import './URLField.css';
import InputField from '../InputField/InputField';
import { FaMinusCircle, FaVideo } from '@/Shared/Lib/UI/Icons';
import { MediaURL } from '@/Shared/Types';
import { MessageHelper } from '@/Shared/Helpers';
import { useFormikContext } from '@/Shared/Lib/Logic';
import { ConfirmHook } from '@/Shared/Logic/Hooks/TechnicalHooks/useConfirm';

interface URLFieldProps<T> {
	index: number,
	label: string,
	name: string,
	placeholder: string,
	fieldValues: MediaURL[],
	confirmHook: ConfirmHook

}

const URLField: FC<URLFieldProps<any>> = ({ confirmHook, index, label, name, placeholder, fieldValues }) => {

	const { setFieldValue } = useFormikContext();

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const url = event.currentTarget.value;

		if (url.length === 0) {
			const newValues = fieldValues.filter((_, fieldIndex) => index !== fieldIndex);
			setFieldValue(name, [...newValues], true);
			return;
		}

		const existingMedia = fieldValues.find((_, fieldIndex) => index === fieldIndex);


		if (existingMedia) {
			existingMedia.url = url;
			//existingMedia.small = url;
			fieldValues[index] = existingMedia;

			setFieldValue(name, [...fieldValues], true);
			return;
		}

		const newValue = new MediaURL(url, 'video');
		setFieldValue(name, [...fieldValues, newValue], true);
	}


	const handleDeleteItem = async () => {
		const confirmed = await confirmHook.openConfirm?.({
			title: MessageHelper.MODAL.CONFIRM.TITLE,
			content: MessageHelper.MODAL.CONFIRM.REMOVING("Video"),
		});
		if (confirmed) {
			executeDeleteItem();
		}
	};

	const executeDeleteItem = () => {
		const filtered = fieldValues.filter((_, currentIndex) => currentIndex !== index);
		setFieldValue(name, filtered, true);
	}

	return (
		<div className="URLField video-field__wrapper" data-testid="URLField">

			<InputField
				label={label}
				icon={<FaVideo />}
				name={`URLField-${name}-${index}`}
				placeholder={placeholder}
				type='url'
				autoComplete='on'
				value={fieldValues[index]?.url ?? ""}
				onChange={handleChange} />
			<FaMinusCircle 
			className='video-field-remove__icon' 
			onClick={handleDeleteItem} 
			title='Cliquer pour retirer le lien'
			/>
		</div>
	);
}

export default URLField;
